// @ts-check
import React from 'react';

const Support = () => {
  return (
    <div className="container">
      <h2>
        <span className="highlight-gold" data-testid="support">
          Support
        </span>
      </h2>
      <section className="mb-7">
        <h3>Contact Us</h3>
        <ul className="pl-0 m-0 list-unstyled">
          <li className="mb-1">
            <strong>Email:</strong>{' '}
            <a href="mailto:aacb@asu.edu">aacb@asu.edu</a>
          </li>
          <li className="mb-1">
            <strong>Slack channel:</strong>{' '}
            <a
              href="https://asu-community.slack.com/archives/C03MN8FTMGD"
              target="_blank"
              rel="noreferrer"
            >
              #aacb_support
            </a>
          </li>
          <li className="mb-1">
            <strong>Feedback: </strong>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeAlPrRi19Baa_T1C-EvxB9uH6PTyvX7WzwbvBN60ib3VbzqQ/viewform?usp=sf_link"
              target="_blank"
              rel="noreferrer"
            >
              Campaign Builder Feedback Form
            </a>
          </li>
        </ul>
      </section>
      <section className="mb-7">
        <h3>Resources</h3>
        <ul className="pl-0 m-0 list-unstyled">
          <li className="mb-1">
            <a
              href="https://docs.google.com/document/d/171-ufmt8mPPO6stdwjYHTtJKrWX-EJYVgF-4yjXZPL4/edit?tab=t.0#heading=h.yx5eza9fq6wk"
              target="_blank"
              rel="noreferrer"
              data-ga-event="link"
              data-ga-action="click"
              data-ga-name="onclick"
              data-ga-type="external link"
              data-ga-region="main content"
              data-ga-section="Support Resources"
              data-ga-component=""
              data-ga-text="Training Materials"
            >
              Training Materials
            </a>
          </li>
          <li className="mb-1">
            <a
              href="https://docs.google.com/spreadsheets/d/1pdhpt_jn9wdIEVxcmOUJTb133QJBIYl0agPEqNxesHM/edit#gid=312242724"
              target="_blank"
              rel="noreferrer"
              data-ga-event="link"
              data-ga-action="click"
              data-ga-name="onclick"
              data-ga-type="external link"
              data-ga-region="main content"
              data-ga-section="Support Resources"
              data-ga-component=""
              data-ga-text="Filters Dictionary"
            >
              Filters Dictionary
            </a>
          </li>
          <li className="mb-1">
            <a
              href="https://docs.google.com/document/d/1N35nsOAMO12rwqw_yUJz4JuccFQb1p0apngaqZF-El4/edit?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              Release Notes
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
};

export { Support };
